// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d-flex {
  display: flex;
}

.d-col {
  flex-direction: column;
}

.d-row {
  flex-direction: row;
}

.col {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  flex-direction: row;
}

.row-reverse {
  flex-direction: row-reverse;
}

.col-reverse {
  flex-direction: column-reverse;
}

.grow {
  flex-grow: 1;
  flex-basis: 0;
}

.grow-0 {
  flex-grow: 0;
  flex-basis: 0;
}

.grow-2 {
  flex-grow: 2;
  flex-basis: 0;
}

.overlay {
  overflow: overlay;
}

.scroll {
  overflow: scroll;
}

.basis {
  flex-basis: fit-content;
  width: 0;
}

.none {
  display: none !important;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.wrap {
  flex-wrap: wrap;
}

.align-center {
  display: flex;
  align-items: center;
}

.align-start {
  display: flex;
  align-items: flex-start;
}

.align-end {
  display: flex;
  align-items: flex-end;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-start {
  display: flex;
  justify-content: flex-start;
}

.space-between {
  display: flex;
  justify-content: space-between;
}

.cover {
  object-fit: cover;
}

.contain {
  object-fit: contain;
}

.shine {
  transition: 0.1s all;
}

.shine:hover {
  filter: brightness(1.1);
  backdrop-filter: brightness(1.4);
}

.shine:active {
  background-color: rgba(255, 255, 255, 0.2);
}

.shine:focus-visible {
  background-color: rgba(255, 255, 255, 0.2);
}

.scale:hover,
.scale:focus-visible {
  scale: 1.1;
}

.gap-1 {
  gap: 1px;
}

.gap-2 {
  gap: 2px;
}

.gap-3 {
  gap: 3px;
}

.gap-4 {
  gap: 4px;
}

.gap-5 {
  gap: 5px;
}

.gap-6 {
  gap: 6px;
}

.gap-7 {
  gap: 7px;
}

.gap-8 {
  gap: 8px;
}

.gap-9 {
  gap: 9px;
}

.gap-10 {
  gap: 10px;
}

.gap-15 {
  gap: 15px;
}

.gap-20 {
  gap: 20px;
}

.gap-25 {
  gap: 25px;
}

.gap-30 {
  gap: 30px;
}

.gap-40 {
  gap: 40px;
}

.gap-50 {
  gap: 50px;
}

.gap-100 {
  gap: 100px;
}

.gap-150 {
  gap: 150px;
}

.gap-200 {
  gap: 200px;
}

.vh100 {
  min-height: 100dvh;
}

.vw100 {
  min-width: 100vw;
}

.w0 {
  width: 0%;
}

.w10 {
  width: 10%;
}

.w20 {
  width: 20%;
}

.w30 {
  width: 30%;
}

.w40 {
  width: 40%;
}

.w50 {
  width: 50%;
}

.w60 {
  width: 60%;
}

.w70 {
  width: 70%;
}

.w80 {
  width: 80%;
}

.w90 {
  width: 90%;
}

.w100 {
  width: 100%;
}

.h0 {
  max-height: 0%;
}

.h10 {
  max-height: 10%;
}

.h20 {
  max-height: 20%;
}

.h30 {
  max-height: 30%;
}

.h40 {
  max-height: 40%;
}

.h50 {
  max-height: 50%;
}

.h60 {
  max-height: 60%;
}

.h70 {
  max-height: 70%;
}

.h80 {
  max-height: 80%;
}

.h90 {
  max-height: 90%;
}

.h100 {
  height: 100%;
}

.block {
  width: 100%;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.fixed {
  position: fixed;
}

.sticky {
  position: sticky;
}

.p-center {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.p-top {
  top: 0;
}

.p-bottom {
  bottom: 0;
}

.p-left {
  left: 0;
}

.p-right {
  right: 0;
}

.z-1 {
  z-index: 1;
}

.z-2 {
  z-index: 2;
}

.z-3 {
  z-index: 3;
}

.z-4 {
  z-index: 4;
}

.z-5 {
  z-index: 5;
}

.z-10 {
  z-index: 5;
}

.letter-spacing {
  letter-spacing: 3px;
}

.bold {
  font-weight: normal;
}

.italic {
  font-style: italic;
}

.mono {
  font-family: monospace;
}

.line-height {
  line-height: 24px;
}

.line-height-20 {
  line-height: 20px;
}

.line-height-25 {
  line-height: 25px;
}

.weight-300 {
  font-weight: 300;
}

.weight-400 {
  font-weight: 400;
}

.weight-600 {
  font-weight: 600;
}

.weight-800 {
  font-weight: 800;
}

.uppercase {
  text-transform: uppercase;
}

.strike {
  text-decoration: line-through;
}

.capital {
  text-transform: capitalize;
}

.text-center {
  text-align: center;
}

.text-start {
  text-align: start;
}

.text-end {
  text-align: end;
}

.nowrap {
  white-space: nowrap;
  flex-wrap: nowrap;
}

.white-nowrap {
  white-space: nowrap;
}

.white_space_normal {
  white-space: normal;
}

.white_space_preline {
  white-space: pre-line;
}

.missingText {
  min-height: 19px;
}

.letter-space-1 {
  letter-spacing: 1px;
}

.letter-space-2 {
  letter-spacing: 2px;
}

.letter-space-3 {
  letter-spacing: 3px;
}

.underline {
  text-decoration: underline;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.font-6 {
  font-size: 6px;
}

.font-8 {
  font-size: 8px;
}

.font-10 {
  font-size: 10px;
}

.font-12 {
  font-size: 12px;
}

.font-14 {
  font-size: 14px;
}

.font-16 {
  font-size: 16px;
}

.font-18 {
  font-size: 18px;
}

.font-20 {
  font-size: 20px;
}

.font-22 {
  font-size: 22px;
}

.font-24 {
  font-size: 24px;
}

.font-26 {
  font-size: 26px;
}

.font-28 {
  font-size: 28px;
}

.font-30 {
  font-size: 30px;
}

.font-32 {
  font-size: 32px;
}

.font-34 {
  font-size: 34px;
}

.font-36 {
  font-size: 36px;
}

.font-38 {
  font-size: 38px;
}

.font-40 {
  font-size: 40px;
}

.font-42 {
  font-size: 42px;
}

.font-44 {
  font-size: 44px;
}

.font-46 {
  font-size: 46px;
}

.font-48 {
  font-size: 48px;
}

.font-50 {
  font-size: 50px;
}

.font-58 {
  font-size: 58px;
}

h1 {
  font-size: clamp(28px, 5vw, 48px);
}

.h2 {
  font-size: clamp(28px, 5vw, 34px);
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.b-box {
  box-sizing: border-box;
}

.overflow-auto {
  overflow: auto;
}

.overflow-x-auto {
  overflow-x: auto;
}

.overflow-hidden {
  overflow: hidden;
}

.hidden {
  visibility: hidden;
}

.opacity-100 {
  opacity: 1;
}

.opacity-90 {
  opacity: 0.9;
}

.opacity-80 {
  opacity: 0.8;
}

.opacity-75 {
  opacity: 0.75;
}

.opacity-60 {
  opacity: 0.6;
}

.opacity-50 {
  opacity: 0.5;
}

.opacity-40 {
  opacity: 0.4;
}

.opacity-30 {
  opacity: 0.3;
}

.opacity-20 {
  opacity: 0.2;
}

.opacity-10 {
  opacity: 0.1;
}

.opacity-40 {
  opacity: 0.4;
}

.opacity-0 {
  opacity: 0;
}

.shadow {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.35);
}

.pointer {
  cursor: pointer;
}

.cursor-text {
  cursor: text;
}

.no-pointer {
  pointer-events: none;
}

.radius-8 {
  border-radius: 8px;
}

.radius-10 {
  border-radius: 10px;
}

.radius-12 {
  border-radius: 12px;
}

.radius-15 {
  border-radius: 15px;
}

.auto-pointer {
  pointer-events: auto;
}

.round {
  border-radius: 50%;
}

.curve {
  border-radius: 7px;
}

.curve-top {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.min-max-content {
  min-width: max-content;
}

.w-fit-content {
  width: fit-content;
}

.ratio {
  aspect-ratio: 1;
}

.glass {
  background: rgba(197, 207, 197, 0.15);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(197, 207, 197, 0.3);
}

.frost {
  background-color: rgba(255, 255, 255, 0.05);
}

@media only screen and (max-width: 576px) {
  .sm-font-35 {
    font-size: 35px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/helper.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,2BAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAKA;EACE,uBAAA;EACA,QAAA;AAFF;;AAKA;EACE,wBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAMA;EACE,aAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,qBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,yBAAA;AAHF;;AAMA;EACE,aAAA;EACA,2BAAA;AAHF;;AAMA;EACE,aAAA;EACA,8BAAA;AAHF;;AAMA;EACE,iBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,oBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,gCAAA;AAHF;;AAMA;EACE,0CAAA;AAHF;;AAMA;EACE,0CAAA;AAHF;;AAMA;;EAEE,UAAA;AAHF;;AAMA;EACE,QAAA;AAHF;;AAMA;EACE,QAAA;AAHF;;AAMA;EACE,QAAA;AAHF;;AAMA;EACE,QAAA;AAHF;;AAMA;EACE,QAAA;AAHF;;AAMA;EACE,QAAA;AAHF;;AAMA;EACE,QAAA;AAHF;;AAMA;EACE,QAAA;AAHF;;AAMA;EACE,QAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,UAAA;AAHF;;AAMA;EACE,UAAA;AAHF;;AAMA;EACE,UAAA;AAHF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,SAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,WAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,WAAA;AANF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AANF;;AASA;EACE,MAAA;AANF;;AASA;EACE,SAAA;AANF;;AASA;EACE,OAAA;AANF;;AASA;EACE,QAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,sBAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,0BAAA;AARF;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,eAAA;AARF;;AAWA;EACE,mBAAA;EACA,iBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,qBAAA;AARF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,0BAAA;AATF;;AAYA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,iCAAA;AATF;;AAYA;EACE,iCAAA;AATF;;AAcA;EACE,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAXF;;AAcA;EACE,sBAAA;AAXF;;AAcA;EACE,cAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;;AAcA;EACE,UAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,aAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,UAAA;AAXF;;AAcA;EACE,4CAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,oBAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,oBAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;;AAcA;EACE,2BAAA;EACA,4BAAA;AAXF;;AAcA;EACE,sBAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,0BAAA;EACA,kCAAA;EACA,0CAAA;AAXF;;AAcA;EACE,2CAAA;AAXF;;AAcA;EACE;IACE,eAAA;EAXF;AACF","sourcesContent":["//FLEXBOX\n\n.d-flex {\n  display: flex;\n}\n\n.d-col {\n  flex-direction: column;\n}\n\n.d-row {\n  flex-direction: row;\n}\n\n.col {\n  display: flex;\n  flex-direction: column;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n}\n\n.row-reverse{\n  flex-direction: row-reverse;\n}\n\n.col-reverse{\n  flex-direction: column-reverse;\n}\n\n.grow {\n  flex-grow: 1;\n  flex-basis: 0;\n}\n\n.grow-0 {\n  flex-grow: 0;\n  flex-basis: 0;\n}\n\n.grow-2 {\n  flex-grow: 2;\n  flex-basis: 0;\n}\n\n.overlay {\n  overflow: overlay;\n}\n\n.scroll {\n  overflow: scroll;\n}\n\n\n.basis {\n  flex-basis: fit-content;\n  width: 0;\n}\n\n.none {\n  display: none !important;\n}\n\n.center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.wrap {\n  flex-wrap: wrap;\n}\n\n\n.align-center {\n  display: flex;\n  align-items: center;\n}\n\n.align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n.align-end {\n  display: flex;\n  align-items: flex-end;\n}\n\n.justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n.justify-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.justify-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n.cover {\n  object-fit: cover;\n}\n\n.contain {\n  object-fit: contain;\n}\n\n.shine {\n  transition: 0.1s all;\n}\n\n.shine:hover {\n  filter: brightness(1.1);\n  backdrop-filter: brightness(1.4);\n}\n\n.shine:active {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.shine:focus-visible {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.scale:hover,\n.scale:focus-visible {\n  scale: 1.1;\n}\n\n.gap-1 {\n  gap: 1px;\n}\n\n.gap-2 {\n  gap: 2px;\n}\n\n.gap-3 {\n  gap: 3px;\n}\n\n.gap-4 {\n  gap: 4px;\n}\n\n.gap-5 {\n  gap: 5px;\n}\n\n.gap-6 {\n  gap: 6px;\n}\n\n.gap-7 {\n  gap: 7px;\n}\n\n.gap-8 {\n  gap: 8px;\n}\n\n.gap-9 {\n  gap: 9px;\n}\n\n.gap-10 {\n  gap: 10px;\n}\n\n.gap-15 {\n  gap: 15px;\n}\n\n.gap-20 {\n  gap: 20px;\n}\n\n.gap-25 {\n  gap: 25px;\n}\n\n.gap-30 {\n  gap: 30px;\n}\n\n.gap-40 {\n  gap: 40px;\n}\n\n.gap-50 {\n  gap: 50px;\n}\n\n.gap-100 {\n  gap: 100px;\n}\n\n.gap-150 {\n  gap: 150px;\n}\n\n.gap-200 {\n  gap: 200px;\n}\n\n//SIZING\n\n\n.vh100 {\n  min-height: 100dvh;\n}\n\n.vw100 {\n  min-width: 100vw;\n}\n\n.w0 {\n  width: 0%;\n}\n\n.w10 {\n  width: 10%;\n}\n\n.w20 {\n  width: 20%;\n}\n\n.w30 {\n  width: 30%;\n}\n\n.w40 {\n  width: 40%;\n}\n\n.w50 {\n  width: 50%;\n}\n\n.w60 {\n  width: 60%;\n}\n\n.w70 {\n  width: 70%;\n}\n\n.w80 {\n  width: 80%;\n}\n\n.w90 {\n  width: 90%;\n}\n\n.w100 {\n  width: 100%;\n}\n\n.h0 {\n  max-height: 0%;\n}\n\n.h10 {\n  max-height: 10%;\n}\n\n.h20 {\n  max-height: 20%;\n}\n\n.h30 {\n  max-height: 30%;\n}\n\n.h40 {\n  max-height: 40%;\n}\n\n.h50 {\n  max-height: 50%;\n}\n\n.h60 {\n  max-height: 60%;\n}\n\n.h70 {\n  max-height: 70%;\n}\n\n.h80 {\n  max-height: 80%;\n}\n\n.h90 {\n  max-height: 90%;\n}\n\n.h100 {\n  height: 100%;\n}\n\n.block {\n  width: 100%;\n}\n\n.relative {\n  position: relative;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.sticky {\n  position: sticky;\n}\n\n.p-center {\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.p-top {\n  top: 0;\n}\n\n.p-bottom {\n  bottom: 0;\n}\n\n.p-left {\n  left: 0;\n}\n\n.p-right {\n  right: 0;\n}\n\n.z-1 {\n  z-index: 1;\n}\n\n.z-2 {\n  z-index: 2;\n}\n\n.z-3 {\n  z-index: 3;\n}\n\n.z-4 {\n  z-index: 4;\n}\n\n.z-5 {\n  z-index: 5;\n}\n\n.z-10 {\n  z-index: 5;\n}\n\n//TEXT\n\n.letter-spacing {\n  letter-spacing: 3px;\n}\n\n.bold {\n  font-weight: normal;\n}\n\n.italic {\n  font-style: italic;\n}\n\n.mono{\n  font-family: monospace;\n}\n\n.line-height {\n  line-height: 24px;\n}\n\n.line-height-20 {\n  line-height: 20px;\n}\n\n.line-height-25 {\n  line-height: 25px;\n}\n\n.weight-300 {\n  font-weight: 300;\n}\n\n.weight-400 {\n  font-weight: 400;\n}\n\n.weight-600 {\n  font-weight: 600;\n}\n\n.weight-800 {\n  font-weight: 800;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.strike {\n  text-decoration: line-through;\n}\n\n.capital {\n  text-transform: capitalize;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-start {\n  text-align: start;\n}\n\n.text-end {\n  text-align: end;\n}\n\n.nowrap {\n  white-space: nowrap;\n  flex-wrap: nowrap;\n}\n\n.white-nowrap {\n  white-space: nowrap;\n}\n\n.white_space_normal {\n  white-space: normal;\n}\n\n.white_space_preline {\n  white-space: pre-line;\n  ;\n}\n\n.missingText {\n  min-height: 19px;\n}\n\n.letter-space-1 {\n  letter-spacing: 1px;\n}\n\n.letter-space-2 {\n  letter-spacing: 2px;\n}\n\n.letter-space-3 {\n  letter-spacing: 3px;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.font-6 {\n  font-size: 6px;\n}\n\n.font-8 {\n  font-size: 8px;\n}\n\n.font-10 {\n  font-size: 10px;\n}\n\n.font-12 {\n  font-size: 12px;\n}\n\n.font-14 {\n  font-size: 14px;\n}\n\n.font-16 {\n  font-size: 16px;\n}\n\n.font-18 {\n  font-size: 18px;\n}\n\n.font-20 {\n  font-size: 20px;\n}\n\n.font-22 {\n  font-size: 22px;\n}\n\n.font-24 {\n  font-size: 24px;\n}\n\n.font-26 {\n  font-size: 26px;\n}\n\n.font-28 {\n  font-size: 28px;\n}\n\n.font-30 {\n  font-size: 30px;\n}\n\n.font-32 {\n  font-size: 32px;\n}\n\n.font-34 {\n  font-size: 34px;\n}\n\n.font-36 {\n  font-size: 36px;\n}\n\n.font-38 {\n  font-size: 38px;\n}\n\n.font-40 {\n  font-size: 40px;\n}\n\n.font-42 {\n  font-size: 42px;\n}\n\n.font-44 {\n  font-size: 44px;\n}\n\n.font-46 {\n  font-size: 46px;\n}\n\n.font-48 {\n  font-size: 48px;\n}\n\n.font-50 {\n  font-size: 50px;\n}\n\n.font-58 {\n  font-size: 58px;\n}\n\nh1{\n  font-size: clamp(28px, 5vw, 48px);\n}\n\n.h2{\n  font-size: clamp(28px, 5vw, 34px);\n}\n\n//UTILITY\n\n.noselect {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.b-box {\n  box-sizing: border-box;\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflow-x-auto {\n  overflow-x: auto;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.opacity-100 {\n  opacity: 1;\n}\n\n.opacity-90 {\n  opacity: 0.9;\n}\n\n.opacity-80 {\n  opacity: 0.8;\n}\n\n.opacity-75 {\n  opacity: 0.75;\n}\n\n.opacity-60 {\n  opacity: 0.6;\n}\n\n.opacity-50 {\n  opacity: 0.5;\n}\n\n.opacity-40 {\n  opacity: 0.4;\n}\n\n.opacity-30 {\n  opacity: 0.3;\n}\n\n.opacity-20 {\n  opacity: 0.2;\n}\n\n.opacity-10 {\n  opacity: 0.1;\n}\n\n.opacity-40 {\n  opacity: 0.4;\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.shadow {\n  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.35);\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.cursor-text {\n  cursor: text;\n}\n\n.no-pointer {\n  pointer-events: none;\n}\n\n.radius-8 {\n  border-radius: 8px;\n}\n\n.radius-10 {\n  border-radius: 10px;\n}\n\n.radius-12 {\n  border-radius: 12px;\n}\n\n.radius-15 {\n  border-radius: 15px;\n}\n\n.auto-pointer {\n  pointer-events: auto;\n}\n\n.round {\n  border-radius: 50%;\n}\n\n.curve {\n  border-radius: 7px;\n}\n\n.curve-top {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.min-max-content {\n  min-width: max-content;\n}\n\n.w-fit-content {\n  width: fit-content;\n}\n\n.ratio {\n  aspect-ratio: 1;\n}\n\n.glass {\n  background: rgba(197, 207, 197, 0.15);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border: 1px solid rgba(197, 207, 197, 0.3);\n}\n\n.frost {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n@media only screen and (max-width: 576px) {\n  .sm-font-35 {\n    font-size: 35px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
